import './App.scss';

import { Grid, GridItem } from '@flos/react-ui';
import React, { FunctionComponent, useContext } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import DebugBanners from './components/DebugBanners';
import Form from './components/Form';
import Highway from './components/Highway';
import Page from './components/Page';
import ReceiptPage from './components/Receipt/ReceiptPage';
import { ConfigContext } from './context/ConfigContext';
import useAppState from './state/appState';
import { getQueryParm } from './helpers/getQueryParm';

const DEBUG_HASH = '#debug';

const Contents = () => {
    const config = useContext(ConfigContext);
    // AB split test
    sessionStorage.setItem('ab-highway-test', window.location.hash);

    // 2024.11.14 - FRY
    // We need to make sure that the topConfig is set in the appState as early as possible
    // (it used to be set in a useEffect in Form.tsx, but that's too late for API integrations that
    // take place already when the app is loading)
    const setTopConfig = useAppState((state) => state.setTopConfig);
    setTopConfig(config);

    // 2025.05.05 - FRY
    // The paf form (work retention / arbejdsfastholdelse) is a special form, that is sent out to customers from TopPro.
    // This claim number is passed onlong from TopPro as a querystring parameter, and needs to be set in the app state, such
    // that is can be appended to the payload when the form is submitted.
    const claimNumber = getQueryParm('claimNumber');
    const setClaimNumber = useAppState((state) => state.setClaimNumber);
    if (claimNumber) {
        setClaimNumber(claimNumber);
    }

    return (
        <div className="claim-form-app container">
            <BrowserRouter basename={config.appBasePath}>
                <Routes>
                    <Route path="/" element={<Navigate to={config.highwayUrl} />} />
                    <Route path="/highway" element={<Highway basePath={config.appBasePath} />} />
                    <Route path=":formId" element={<Form.InitFromRoute />}>
                        <Route path=":pageId" element={<Page.InitFromRoute />} />
                    </Route>
                    <Route path=":formId/kvittering" />
                    {/*receipt-page URL for www forms*/}
                    <Route path="/anmeld-skade/kvittering" element={<ReceiptPage />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
};

const App: FunctionComponent = () => {
    const [showDebugBanner, setShowDebugBanner] = React.useState(false);

    React.useEffect(() => {
        if (window.location.hash === DEBUG_HASH) {
            setShowDebugBanner(true);
        }
        const onHashChange = (event: HashChangeEvent) => {
            setShowDebugBanner(event.newURL.endsWith(DEBUG_HASH));
        };

        window.addEventListener('hashchange', onHashChange);

        return () => window.removeEventListener('hashchange', onHashChange);
    }, []);

    if (showDebugBanner) {
        return (
            <Grid className="u-Space">
                <GridItem span={7}>
                    <Contents />
                </GridItem>

                <GridItem span={1} />

                <GridItem span={4}>
                    <DebugBanners />
                </GridItem>
            </Grid>
        );
    }

    // This is what App will normally show
    return <Contents />;
};

export default App;
